import { Button, Stack, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import CrownIcon from 'assets/icons/CrownIcon';
import { useSubscription } from 'services/hooks';
import { locations } from 'services/routes/locations';
import { selectRemainingLoopUploads } from 'services/store/user/selectors';
import useAnalytics from 'services/hooks/analytics/useAnalytics';
import { events } from 'services/analytics';
import useUrlLocation from 'services/hooks/urlLocation';

const UserLoopUpgradeMessage = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const location = useLocation();
  const { track } = useAnalytics();
  const eventLocation = useUrlLocation();

  const { isFreeAccount } = useSubscription();

  const remainingLoopUploads = useSelector(selectRemainingLoopUploads);

  if (!isFreeAccount) {
    return null;
  }

  const handleUpgradeClick = () => {
    track(events.upgradeSubscription('user_loop_selector', eventLocation));
  };

  const { remaining = 0 } = remainingLoopUploads || {};

  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: 'space-between',
      }}
    >
      <Stack direction="row" gap={theme.spacing(0.5)}>
        <CrownIcon />
        <Typography
          sx={{
            fontSize: 12,
            color: theme.palette.warning.main,
          }}
        >
          {t('aiMusicGenerator:userLoopSelector:upgradeMessage', { remaining })}
        </Typography>
      </Stack>
      {/* @ts-expect-error `component` property actually exists */}
      <Button
        disableFocusRipple
        disableRipple
        component={Link}
        onClick={handleUpgradeClick}
        to={{
          pathname: locations.subscription.pricing.pathname(''),
          state: { from: location.pathname },
        }}
        sx={{
          padding: 0,
          fontSize: 12,
          textTransform: 'uppercase',
        }}
      >
        {t('aiMusicGenerator:upgrade:action')}
      </Button>
    </Stack>
  );
};

export default UserLoopUpgradeMessage;
